import React, {useState} from 'react'
import {Box, useStyleConfig} from '@chakra-ui/react'
import TopCard from './partials/top-card'
import PropTypes from 'prop-types'
import {Swiper, SwiperSlide} from 'swiper/react'
import {FreeMode, Mousewheel} from 'swiper/modules'
import {remCalc} from '../../../theme/_utils'

export const PLPTopCards = ({cards = []}) => {
    const styles = useStyleConfig('PlpTopCards', {})
    const [hasScrolledRight, setHasScrolledRight] = useState(false)

    const gapLg = remCalc(8)
    const n = cards.length || 1

    return (
        <Box {...styles?.outerContainer} data-testid="plp-top-cards-container">
            <Box
                {...styles?.cardsOuterContainer}
                sx={{
                    '.swiper': {
                        width: {
                            base: hasScrolledRight
                                ? `calc(100% + ${remCalc(24)})`
                                : `calc(100% + ${remCalc(12)})`,
                            lg: '100%',
                        },
                        marginLeft: {base: hasScrolledRight ? remCalc(-12) : '0', lg: '0'},
                        overflow: 'hidden',
                    },
                    '.swiper-wrapper': {
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'stretch',
                        justifyContent: 'flex-start',
                        paddingTop: remCalc(6),
                        paddingBottom: remCalc(6),
                    },
                    '.swiper-slide': {
                        width: 'auto',
                        maxW: {
                            base: remCalc(280),
                            sm: remCalc(280),
                            md: remCalc(472),
                            lg: remCalc(472),
                        },
                        flexShrink: 0,
                        height: 'auto',
                        marginRight: {
                            base: remCalc(6),
                            sm: remCalc(6),
                            md: remCalc(8),
                            lg: 0,
                        },
                        '&:last-child': {
                            marginRight: 0,
                        },
                    },
                    '.swiper:not(.swiper-initialized) .swiper-slide': {
                        width: {
                            lg: `calc((100% - ${gapLg} * ${n - 1}) / ${n})`,
                        },
                        marginRight: {lg: gapLg},
                        '&:last-of-type': {
                            marginRight: {lg: 0},
                        },
                    },
                }}
            >
                <Swiper
                    modules={[FreeMode, Mousewheel]}
                    slidesPerView="auto"
                    spaceBetween={0}
                    freeMode={true}
                    grabCursor={true}
                    mousewheel={{forceToAxis: true, sensitivity: 1, releaseOnEdges: true}}
                    onProgress={(swiper) => {
                        setHasScrolledRight(swiper.progress > 0)
                    }}
                    breakpoints={{
                        1024: {
                            slidesPerView: cards.length || 1,
                            spaceBetween: 8,
                            freeMode: false,
                            grabCursor: false,
                            allowTouchMove: false,
                            mousewheel: false,
                        },
                    }}
                >
                    {cards.map((card, key) => {
                        return (
                            <SwiperSlide key={key}>
                                <TopCard card={card} />
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
            </Box>
        </Box>
    )
}

PLPTopCards.propTypes = {
    cards: PropTypes.array,
    category: PropTypes.object,
}
